import { format, parse } from 'date-fns'
import lv from 'date-fns/locale/lv'

const getLocalizedMonth = (date: Date) => {
  return format(date, 'LLLL', { locale: lv })
}

export const getLocalizedDate = (date: string): string => {
  if (!date) {
    return ''
  }

  let parsedDate: Date | null = null

  // TODO: Drupal CMS returns dates wrapped in HTML time tags. Configure proper date format in Drupal CMS instead
  const datetimeMatch = date.match(/datetime="([^"]+)"/)
  const dateString = datetimeMatch ? datetimeMatch[1] : date

  try {
    if (dateString.includes('T') && (dateString.includes('+') || dateString.includes('Z'))) {
      parsedDate = new Date(dateString)
    } else if (dateString.includes('/')) {
      if (dateString.includes(',') && dateString.includes('-')) {
        parsedDate = parse(dateString, 'E, MM/dd/yyyy - HH:mm', new Date())
      } else {
        parsedDate = parse(dateString, 'MM/dd/yyyy', new Date())
      }
    } else if (dateString.includes('.')) {
      parsedDate = parse(dateString, 'dd.MM.yyyy.', new Date())
    }

    if (parsedDate && !isNaN(parsedDate.getTime())) {
      return `${format(parsedDate, 'dd')}. ${getLocalizedMonth(parsedDate)} ${format(
        parsedDate,
        'yyyy'
      )}`
    }
  } catch {
    console.error('Error parsing date', dateString)
  }

  return ''
}
